/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateProductMovementHistoryDto = {
    /**
     * Warehouse inventory product ID (for serialized units)
     */
    warehouseInventoryProductId?: number;
    /**
     * Product ID (for catalog-level changes)
     */
    productId?: number;
    /**
     * Type of event
     */
    eventType: CreateProductMovementHistoryDto.eventType;
    /**
     * Array of field names that changed
     */
    changedFields?: Array<string>;
    /**
     * Previous values of changed fields
     */
    previousValue?: Record<string, any>;
    /**
     * New values of changed fields
     */
    newValue?: Record<string, any>;
    /**
     * User ID who performed the action
     */
    performedById?: string;
    /**
     * Type of related entity
     */
    relatedEntityType?: string;
    /**
     * ID of related entity
     */
    relatedEntityId?: number;
    /**
     * Location ID where event occurred
     */
    locationId?: number;
    /**
     * Source location ID (for transfers)
     */
    sourceLocationId?: number;
    /**
     * Destination location ID (for transfers)
     */
    destinationLocationId?: number;
    /**
     * Additional notes or context (string for legacy, object for structured data)
     */
    notes?: (string | Record<string, any>);
    /**
     * Transfer code
     */
    transferCode?: string;
    /**
     * Order code
     */
    orderCode?: string;
    /**
     * Record code
     */
    recordCode?: string;
};
export namespace CreateProductMovementHistoryDto {
    /**
     * Type of event
     */
    export enum eventType {
        INVENTORY_REGISTERED = 'INVENTORY_REGISTERED',
        PRODUCT_CREATED = 'PRODUCT_CREATED',
        PRODUCT_DELETED = 'PRODUCT_DELETED',
        INVENTORY_RECORD_CREATED = 'INVENTORY_RECORD_CREATED',
        INVENTORY_RECORD_UPDATED = 'INVENTORY_RECORD_UPDATED',
        INVENTORY_RECORD_COMPLETED = 'INVENTORY_RECORD_COMPLETED',
        INVENTORY_RECORD_CANCELLED = 'INVENTORY_RECORD_CANCELLED',
        INVENTORY_RECORD_DELETED = 'INVENTORY_RECORD_DELETED',
        TRANSFER_CREATED = 'TRANSFER_CREATED',
        TRANSFER_COMPLETED = 'TRANSFER_COMPLETED',
        TRANSFER_CANCELLED = 'TRANSFER_CANCELLED',
        REQUEST_CREATED = 'REQUEST_CREATED',
        REQUEST_RESOLVED = 'REQUEST_RESOLVED',
        SALE_FULFILLMENT_STARTED = 'SALE_FULFILLMENT_STARTED',
        SALE_FULFILLMENT_RECEIVED = 'SALE_FULFILLMENT_RECEIVED',
        SALE_FULFILLMENT_COMPLETED = 'SALE_FULFILLMENT_COMPLETED',
        SALE_FULFILLMENT_FAILED = 'SALE_FULFILLMENT_FAILED',
        RESERVATION_CREATED = 'RESERVATION_CREATED',
        RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
        RESERVATION_RELEASED = 'RESERVATION_RELEASED',
        RESERVATION_EXPIRED = 'RESERVATION_EXPIRED',
        SALE_CREATED = 'SALE_CREATED',
        PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
        PAYMENT_PROCESSED = 'PAYMENT_PROCESSED',
        ORDER_REFUNDED = 'ORDER_REFUNDED',
        ORDER_PARTIALLY_REFUNDED = 'ORDER_PARTIALLY_REFUNDED',
        REFUND_PROCESSED = 'REFUND_PROCESSED',
        ITEM_RETURNED = 'ITEM_RETURNED',
        EXCHANGE_PROCESSED = 'EXCHANGE_PROCESSED',
        ORDER_DELIVERY_UPDATED = 'ORDER_DELIVERY_UPDATED',
        STATUS_CHANGED = 'STATUS_CHANGED',
        AVAILABILITY_STATUS_CHANGED = 'AVAILABILITY_STATUS_CHANGED',
        LOCATION_CHANGED = 'LOCATION_CHANGED',
        PRICE_CHANGED = 'PRICE_CHANGED',
        UNIT_ATTRIBUTE_CHANGED = 'UNIT_ATTRIBUTE_CHANGED',
        PRODUCT_CATALOG_UPDATED = 'PRODUCT_CATALOG_UPDATED',
        PROPERTY_ADDED = 'PROPERTY_ADDED',
        PROPERTY_UPDATED = 'PROPERTY_UPDATED',
        PROPERTY_DELETED = 'PROPERTY_DELETED',
        SAFETY_STOCK_UPDATED_INDIVIDUAL = 'SAFETY_STOCK_UPDATED_INDIVIDUAL',
        SAFETY_STOCK_UPDATED_BULK = 'SAFETY_STOCK_UPDATED_BULK',
        PHYSICAL_COUNT_FINALIZED = 'PHYSICAL_COUNT_FINALIZED',
        ROLE_CREATED = 'ROLE_CREATED',
        ROLE_UPDATED = 'ROLE_UPDATED',
        ROLE_DELETED = 'ROLE_DELETED',
        ROLE_PERMISSIONS_UPDATED = 'ROLE_PERMISSIONS_UPDATED',
        USER_CREATED = 'USER_CREATED',
        USER_UPDATED = 'USER_UPDATED',
        USER_DELETED = 'USER_DELETED',
        USER_ROLES_UPDATED = 'USER_ROLES_UPDATED',
        CUSTOMER_CREATED = 'CUSTOMER_CREATED',
        CUSTOMER_UPDATED = 'CUSTOMER_UPDATED',
        CUSTOMER_DELETED = 'CUSTOMER_DELETED',
        LOGIN_SUCCESS = 'LOGIN_SUCCESS',
        LOGIN_FAILED = 'LOGIN_FAILED',
        ACCOUNT_LOCKED = 'ACCOUNT_LOCKED',
        ACCOUNT_UNLOCKED = 'ACCOUNT_UNLOCKED',
        PASSWORD_RESET_BY_ADMIN = 'PASSWORD_RESET_BY_ADMIN',
        PASSWORD_CHANGED = 'PASSWORD_CHANGED',
        FORCED_PASSWORD_CHANGE = 'FORCED_PASSWORD_CHANGE',
    }
}

